(() => {
 const init = (root = document) => {
  const sections = root.matches?.('[data-lr-section]') ? [root] : root.querySelectorAll('[data-lr-section]');
  sections.forEach(section => {
   if (section.dataset.initialized) return;
   section.dataset.initialized = 'true';
   const kaching=section.querySelector('.lr-kaching[data-lr-fixed-option]');
   if(kaching){
    const fixVariant=()=>{
     const value=kaching.dataset.lrFixedOption;
     kaching.querySelectorAll('select.kaching-bundles-option').forEach(select=>{
      if(select.value!==value&&Array.from(select.options).some(option=>option.value===value)){
       select.value=value;select.dispatchEvent(new Event('change',{bubbles:true}));
      }
     });
    };
    fixVariant();
    const variantObserver=new MutationObserver(fixVariant);
    variantObserver.observe(kaching,{childList:true,subtree:true});
    section.addEventListener('shopify:section:unload',()=>variantObserver.disconnect(),{once:true});
   }
   const slides = Array.from(section.querySelectorAll('.lr-slide'));
   const thumbs = Array.from(section.querySelectorAll('[data-image-select]'));
   let active = 0;
   const show = index => {
    if(!slides.length) return;
    active = (index + slides.length) % slides.length;
    slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===active);});
    thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));
    const count=section.querySelector('.lr-image-count');if(count)count.textContent=`${active+1} / ${slides.length}`;
   };
   thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
   section.querySelector('.lr-prev')?.addEventListener('click',()=>show(active-1));
   section.querySelector('.lr-next')?.addEventListener('click',()=>show(active+1));
   const gallery=section.querySelector('.lr-slides');
   if(gallery){let start=0;gallery.addEventListener('touchstart',e=>{start=e.changedTouches[0].clientX;},{passive:true});gallery.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-start;if(Math.abs(delta)>45)show(active+(delta<0?1:-1));},{passive:true});gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(active+1);}if(e.key==='ArrowLeft'){e.preventDefault();show(active-1);}});}
   const selected=()=>section.querySelector('[data-lr-pack]:checked');
   const updateTotal=()=>{const pack=selected();if(!pack)return;const total=Number(pack.dataset.priceCents)+Array.from(section.querySelectorAll('[data-lr-addon]:checked:not(:disabled)')).reduce((sum,addon)=>sum+Number(addon.dataset.priceCents),0);const formatted=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:section.dataset.currency||'USD'}).format(total/100);section.querySelectorAll('.lr-add-button').forEach(button=>button.textContent=button.dataset.label+' · '+formatted);};
   section.querySelectorAll('[data-lr-pack],[data-lr-addon]').forEach(input=>input.addEventListener('change',updateTotal));
   updateTotal();
   section.querySelectorAll('.lr-add-button').forEach(button=>button.addEventListener('click',async()=>{
    const pack=selected();if(!pack||button.disabled)return;
    const status=section.querySelector('.lr-cart-status');const old=button.textContent;button.disabled=true;button.textContent=window.lumaRideText?.adding||'Adding…';
    status.textContent='';status.removeAttribute('data-error');
    try{
     const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:pack.dataset.variantId,quantity:1,properties:{Pack:pack.value+' backpack'+(pack.value==='1'?'':'s')}},...Array.from(section.querySelectorAll('[data-lr-addon]:checked:not(:disabled)')).map(addon=>({id:addon.dataset.variantId,quantity:1}))]})});
     const data=await response.json();if(!response.ok)throw new Error(data.description||window.lumaRideText?.error||'This item is not available to order yet.');
     status.textContent=(window.lumaRideText?.added||'Added to cart')+'. ';const link=document.createElement('a');link.href=(window.Shopify?.routes?.root||'/')+'cart';link.textContent=window.lumaRideText?.view||'View cart';status.append(link);
    }catch(error){status.textContent=error.message;status.dataset.error='true';}
    finally{button.textContent=old;button.disabled=false;}
   }));
   section.querySelectorAll('[data-date-from]').forEach(el=>{
    const format=days=>{const date=new Date();date.setDate(date.getDate()+Number(days));return new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric'}).format(date);};
    el.textContent=el.dataset.dateFrom===el.dataset.dateTo?format(el.dataset.dateFrom):format(el.dataset.dateFrom)+' – '+format(el.dataset.dateTo);
   });
   section._lrShow=show;
  });
 };
 const revealAnchor = hash => {
  if (!hash) return;
  const target=document.getElementById(decodeURIComponent(hash.slice(1)));
  if(target?.tagName==='DETAILS')target.open=true;
  return target;
 };
 document.addEventListener('DOMContentLoaded',()=>{init();revealAnchor(location.hash);});
 document.addEventListener('click',event=>{
  const link=event.target.closest('a[href]');if(!link)return;
  const url=new URL(link.href,location.href);
  if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash)return;
  const target=revealAnchor(url.hash);if(target){event.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
 });
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:block:select',event=>{
  const slide=event.target.closest('.lr-slide');if(slide){const section=slide.closest('[data-lr-section]');section?._lrShow?.(Number(slide.dataset.imageIndex));}
  const radio=event.target.querySelector?.('[data-lr-pack]');if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
 });
})();


(() => {
 const start = root => {
  root.querySelectorAll('.lr-review-carousel').forEach(carousel => {
   if(carousel.dataset.lrCarouselReady) return;
   carousel.dataset.lrCarouselReady='true';
   const track=carousel.querySelector('[data-lr-review-track]');
   const prev=carousel.querySelector('[data-lr-review-prev]');
   const next=carousel.querySelector('[data-lr-review-next]');
   if(!track||!prev||!next) return;
   const step=()=>{const card=track.firstElementChild;return card?card.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0):track.clientWidth;};
   const update=()=>{
    prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
    const controls=carousel.querySelector('.lr-review-controls');if(controls)controls.hidden=track.scrollWidth<=track.clientWidth+2;
    if(track.classList.contains('lr-mini-review-track')){
     const index=Math.min(track.children.length-1,Math.max(0,Math.round(track.scrollLeft/step())));const card=track.children[index];
     if(card){const height=Math.ceil(card.getBoundingClientRect().height)+2+'px';if(track.style.height!==height)track.style.height=height;}
    }
   };
   prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
   next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
   track.addEventListener('scroll',update,{passive:true});
   track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();track.scrollBy({left:step()*(event.key==='ArrowRight'?1:-1),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}});
   const reviewObserver=new ResizeObserver(update);reviewObserver.observe(track);Array.from(track.children).forEach(card=>reviewObserver.observe(card));update();
  });
  root.querySelectorAll('.lr-kaching[data-lr-auto-addons="true"]').forEach(widget=>{
   if(widget.dataset.lrDefaultsReady) return;
   widget.dataset.lrDefaultsReady='true';
   const preferences=new Map();let queued=false;
   const key=row=>row.querySelector('.kaching-bundles__upsell__link')?.getAttribute('href')?.split('?')[0]||row.querySelector('.kaching-bundles__upsell__text')?.textContent.trim();
   const apply=()=>{
    queued=false;
    widget.querySelectorAll('.kaching-bundles__upsell').forEach(row=>{
     const checkbox=row.querySelector('.kaching-bundles__upsell__checkbox');const id=key(row);
     if(!checkbox||!id)return;
     if(!preferences.has(id))preferences.set(id,true);
     const selected=checkbox.classList.contains('kaching-bundles__upsell__checkbox--selected');
     if(selected!==preferences.get(id))checkbox.click();
    });
   };
   const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(apply);}};
   widget.addEventListener('click',event=>{
    if(!event.isTrusted)return;
    const control=event.target.closest('.kaching-bundles__upsell__checkbox,.kaching-bundles__upsell__text');
    if(!control)return;
    const row=control.closest('.kaching-bundles__upsell');const checkbox=row?.querySelector('.kaching-bundles__upsell__checkbox');
    if(row&&checkbox)preferences.set(key(row),!checkbox.classList.contains('kaching-bundles__upsell__checkbox--selected'));
   },true);
   const observer=new MutationObserver(schedule);observer.observe(widget,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});schedule();
   widget.closest('[data-lr-section]')?.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
  });
 };
 document.addEventListener('DOMContentLoaded',()=>start(document));
 document.addEventListener('shopify:section:load',event=>start(event.target));
})();
